import React from "react";
import { FilterComponentProps } from "../DynamicTableV3";
import { InputNumber } from "antd";

const NumberFilterComponent = ({
  colProp,
  options,
  dataSource,
}: FilterComponentProps) => {
  const optionValue = Array.from(
    new Set(
      dataSource.map(option => {
        if (!option) return 0;
        const value = option[colProp.key];
        if (value === 0) return 0;
        return Number(String(value).replaceAll(",", ""));
      })
    )
  );
  const val: [number, number] = options?.value && (options?.value as any);
  const minOption = Math.min(...optionValue);
  const maxOption = Math.max(...optionValue);
  const minVal = val ? val[0] : minOption;
  const maxVal = val ? val[1] : maxOption;
  const decimal = colProp.decimal ?? 2;
  const decimalStep = Math.pow(10, -decimal);
  return (
    <div
      style={{
        gap: 2,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        textAlign: "center",
      }}
    >
      <InputNumber
        min={minOption}
        max={maxOption}
        style={{ margin: "0 16px" }}
        value={minVal}
        step={decimalStep.toString()}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        stringMode
        controls={false}
        onChange={(e) => {
          options.filterApplyCallback([e, maxVal]);
        }}
      />
      -
      <InputNumber
        min={minOption}
        max={maxOption}
        style={{ margin: "0 16px" }}
        controls={false}
        value={maxVal}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        step={decimalStep.toString()}
        stringMode
        onChange={(e) => {
          options.filterApplyCallback([minVal, e]);
        }}
      />
    </div>
  );
};

export default NumberFilterComponent;
